import { observable, action, computed,makeObservable } from "mobx";

class RabbitMqStore {

    constructor() {
        makeObservable(this);
    }

    // RabbitMq Stomp객체
    @observable
    client;

    @action
    setClient(client) {
        this.client = client;
    }

    get getClient() {
        return this.client;
    }


    /**
     * Ready New
     * @type {[]}
     * @private
     */
    @observable
    _st_rabbit_ready_order = [];

    get getRabbitReadyNew() {
        return this._st_rabbit_ready_order;
    }

    @computed
    get getNewReadyNewYn() {
        return this._st_rabbit_ready_order.length>0?"Y":"N";
    }

    // create 등록시 주문 조회
    @action
    addRabbitReadyNew(mobileOrderNo) {
        this._st_rabbit_ready_order.push(mobileOrderNo);
    }

    // 주문 클릭시 Ready new 객체 제거
    @action
    removeRabbitReadyNew(mobileOrderNo) {
        this._st_rabbit_ready_order = this._st_rabbit_ready_order.filter((item) => (item!==mobileOrderNo));
    }

    /**
     * cooking New
     * @type {[]}
     * @private
     */
    @observable
    _st_rabbit_cooking_order = [];

    get getRabbitCookingNew() {
        return this._st_rabbit_cooking_order;
    }

    @computed
    get getNewCookingNewYn() {
        return this._st_rabbit_cooking_order.length>0?"Y":"N";
    }

    @action
    addRabbitCookingNew(mobileOrderNo) {
        this._st_rabbit_cooking_order.push(mobileOrderNo);
    }

    // 주문 클릭시 Cooking new 객체 제거
    @action
    removeRabbitCookingNew(mobileOrderNo) {
        this._st_rabbit_cooking_order = this._st_rabbit_cooking_order.filter((item, idx) => ( item!==mobileOrderNo ));

    }

    /**
     * delivery New
     * @type {[]}
     * @private
     */
    @observable
    _st_rabbit_delivery_order = [];

    get getRabbitDeliveryNew() {
        return this._st_rabbit_delivery_order;
    }

    @computed
    get getNewDeliveryNewYn() {
        return this._st_rabbit_delivery_order.length>0?"Y":"N";
    }

    // create 등록시 주문 조회
    @action
    addRabbitDeliveryNew(mobileOrderNo) {
        this._st_rabbit_delivery_order.push(mobileOrderNo);
    }

    // 주문 클릭시 Delivery new 객체 제거
    @action
    removeRabbitDeliveryNew(mobileOrderNo) {
        this._st_rabbit_delivery_order = this._st_rabbit_delivery_order.filter((item, idx) => ( item!==mobileOrderNo ));
    }

    @computed
    get getRabbitAllNew() {
        return this._st_rabbit_ready_order.concat(this._st_rabbit_cooking_order, this._st_rabbit_delivery_order);
    }

    @observable
    _st_time_isStartStatus = true;

    @computed
    get getTimeIsStartStatus() {
        return this._st_time_isStartStatus;
    }

    @action
    setTimeIsStartStatus(val) {
        this._st_time_isStartStatus = val;
    }

    @observable
    _st_time_timeout = ''

    @computed
    get getTimeTimeout() {
        return this._st_time_timeout;
    }

    @action
    setTimeTimeout(val) {
        this._st_time_timeout = val;
    }

    @observable
    _st_rmq_check = true

    @computed
    get getRmqCheck() {
        return this._st_rmq_check;
    }

    @action
    setRmqCheck(val) {
        this._st_rmq_check = val;
    }

}

export default new RabbitMqStore();